import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d3497c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_3 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-5" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_vz_form_clone_modal = _resolveComponent("vz-form-clone-modal")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_KTCreateFormModal = _resolveComponent("KTCreateFormModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      addButtonText: `${_ctx.t('pages.form.addForm')}`,
      "bulk-delete-text-for-forms": _ctx.bulkDeleteTextForForms,
      viewName: "forms",
      activityTab: false,
      onQueryUpdate: _ctx.queryUpdate,
      onTableRowClick: _ctx.tableRowClick,
      onFormSubmit: _ctx.submit,
      onCreateForm: _ctx.createForm,
      onSelectedItemsForDelete: _ctx.selectedItemsForDelete,
      permissions: _ctx.permissionModel
    }, {
      "cell-name": _withCtx(({ row: form }) => [
        _createElementVNode("span", null, _toDisplayString(form.name), 1)
      ]),
      "cell-locationRestrict": _withCtx(({ row: form }) => [
        _createElementVNode("span", {
          class: "text-truncate",
          innerHTML: _ctx.format.yesNoToIconPlain(form.locationRestrict)
        }, null, 8, _hoisted_1)
      ]),
      "cell-startDate": _withCtx(({ row: form }) => [
        (form.startDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.format.convertUTCToLocalDate(form.startDate)), 1))
          : _createCommentVNode("", true)
      ]),
      "cell-endDate": _withCtx(({ row: form }) => [
        (form.endDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.format.convertUTCToLocalDate(form.endDate)), 1))
          : _createCommentVNode("", true)
      ]),
      "cell-status": _withCtx(({ row: form }) => [
        (form.status)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': form.status?.toLowerCase() === 'active',
          'badge badge-danger': form.status?.toLowerCase() !== 'active',
        }])
            }, _toDisplayString(_ctx.format.TitleCase(form.status?.toLowerCase())), 3))
          : _createCommentVNode("", true)
      ]),
      "cell-actions": _withCtx(({ row: form }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editForm(form)), ["stop"]),
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_create_form",
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_6, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = form;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_9, 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      "cell-clone": _withCtx(({ row: form }) => [
        _createElementVNode("button", {
          onClick: _withModifiers(($event: any) => (_ctx.resetWebId(form.webId)), ["stop"]),
          type: "button",
          "data-bs-toggle": "dropdown",
          "data-bs-auto-close": "outside",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3",
          "aria-expanded": "false"
        }, _hoisted_12, 8, _hoisted_10),
        _createElementVNode("ul", {
          class: _normalizeClass(["dropdown-menu dropdown-menu-end border clone-form", 'show-form-' + form.webId])
        }, [
          _createElementVNode("li", null, [
            (_ctx.hasPermission(_ctx.permissionModel.create))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (_ctx.setFormCloneData(form, true)), ["stop"]),
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_form_clone",
                  class: "dropdown-item py-2 text-hover-primary",
                  type: "button"
                }, _toDisplayString(_ctx.t("pages.user.clone.title")), 9, _hoisted_13))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "bulk-delete-text-for-forms", "onQueryUpdate", "onTableRowClick", "onFormSubmit", "onCreateForm", "onSelectedItemsForDelete", "permissions"]),
    (_ctx.openCloneModal)
      ? (_openBlock(), _createBlock(_component_vz_form_clone_modal, {
          key: 0,
          form: _ctx.formObj,
          onCloneSubmit: _ctx.refreshList,
          onOnCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCloneModal = false))
        }, null, 8, ["form", "onCloneSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 1,
          viewName: "definitions",
          showDialog: _ctx.showDeleteDialog,
          selectedForAction: [_ctx.selectedForAction.webId],
          deleteText: _ctx.deleteAlertMessage(_ctx.selectedForAction),
          pageName: "form",
          onClose: _cache[3] || (_cache[3] = 
      () => {
        _ctx.showDeleteDialog = false;
        _ctx.refreshList();
      }
    )
        }, null, 8, ["showDialog", "selectedForAction", "deleteText"]))
      : _createCommentVNode("", true),
    _createVNode(_component_KTCreateFormModal, {
      singleForm: _ctx.singleForm,
      onOnSubmit: _ctx.refreshList
    }, null, 8, ["singleForm", "onOnSubmit"]),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "bi bi-layers fs-3",
      viewName: "Forms Activity Pulse",
      type: "100,700,2700,1600,2000,1900,1800"
    }, null, 8, ["refresh"])
  ], 64))
}